import orderBy from 'lodash-es/orderBy';
import { IState } from '..';
import { ITargetedCatalogGroup, ITargetedCatalogItem, ITargetedCatalogSection } from './targetedCatalogInterfaces';

export function getTargetedCatalogSection(state: IState, sectionId: number): ITargetedCatalogSection | undefined {
  const section = state.targetedCatalog.sections[sectionId];

  if (section) {
    const validGroups = section.groupIds.map(x => state.targetedCatalog.groups[x]);

    return {
      ...section,
      groups: getTargetCatalogGroups(
        state,
        validGroups.map(y => y.preseasonCatalogItemGroupId)
      )
    };
  }

  return section;
}

export function getTargetCatalogGroups(state: IState, groupIds: number[]): ITargetedCatalogGroup[] {
  const groups = groupIds.map<ITargetedCatalogGroup>(x => ({
    ...state.targetedCatalog.groups[x],
    products: getTargetCatalogItems(state, state.targetedCatalog.groups[x].productIds)
  }));

  return orderBy<ITargetedCatalogGroup>(groups, x => x.order);
}

export function getTargetCatalogItems(state: IState, itemIds: number[]): ITargetedCatalogItem[] {
  const items = itemIds.map(x => state.targetedCatalog.items[x]);
  return orderBy<ITargetedCatalogItem>(items, x => x.order);
}

export function getTargetedCatalogSections(state: IState): ITargetedCatalogSection[] {
  const sections = Object.values(state.targetedCatalog.sections).map(
    x => getTargetedCatalogSection(state, x.preseasonCatalogSectionId) as ITargetedCatalogSection
  );

  return orderBy<ITargetedCatalogSection>(sections, x => x.order);
}

export function isTargetedCatalogLoaded(state: IState): boolean {
  return Boolean(state.targetedCatalog.loadedAt);
}

export function getTargetGroupRange(state: IState, sectionId: number): { min: number; max: number } {
  const groupOrders = state.targetedCatalog.sections[sectionId].groupIds
    .map(x => state.targetedCatalog.groups[x])
    .map(x => x.order);
  return { max: Math.max(...groupOrders), min: Math.min(...groupOrders) };
}

export function getTargetItemRange(state: IState, itemGroupId: number): { min: number; max: number } {
  const groupOrders = getTargetCatalogItems(state, state.targetedCatalog.groups[itemGroupId].productIds).map(
    x => x.order
  );
  return { max: Math.max(...groupOrders), min: Math.min(...groupOrders) };
}
